import {css} from 'lit';

export const selectOnDarkStyles = css`
  --_select__color: var(--sbkSelectColorFgColorOnLightEnabled);
  --_select__color--disabled: var(--sbkSelectColorFgColorOnLightDisabled);
  --_select__color--error:var(--sbkSelectColorFgColorOnLightError);

  --_select__bg: var(--sbkSelectColorBgColorOnDarkTriggerEnabled);
  --_select__bg--active: var(--sbkSelectColorBgColorOnDarkTriggerActive);
  --_select__bg--hover: var(--sbkSelectColorBgColorOnDarkTriggerHover);
  --_select__bg--focus: var(--sbkSelectColorBgColorOnDarkTriggerFocus);
  --_select__bg--disabled: var(--sbkSelectColorBgColorOnDarkTriggerDisabled);
  --_select__bg--error: var(--sbkSelectColorBgColorOnDarkTriggerError);

  --_select__border: var(--sbkSelectBorderOnDarkEnabled);
  --_select__border--active: var(--sbkSelectBorderOnDarkActive);
  --_select__border--disabled: var(--sbkSelectBorderOnDarkDisabled);
  --_select__border--error: var(--sbkSelectBorderOnDarkError);
  --_select__border--focus: var(--sbkSelectBorderOnDarkFocus);
  --_select__border--hover: var(--sbkSelectBorderOnDarkHover);
  --_select__border--readonly: var(--sbkSelectBorderOnDarkDisabled);


  --_select-flyout__bg: var(--sbkSelectColorBgColorOnDarkFlyoutEnabled);
  --_select-flyout__box-shadow: var(--sbkSelectFlyoutOnDarkShadow);
`;
